import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { closeModal, closeModalWithUpdate } from "../../../features/modal/ModalSlice";
import CustomInputBox from "../../Form/CustomInputBox";
import { Numbers, Phone } from "@mui/icons-material";
import { Box, Stack } from "@mui/material";
import CustomButton from "../../Button/CustomButton";
import apiClient from "../../../services/apiClient";

const EditRequest = () => {
  const [formData, setFormData] = useState({
    user_id: "",
    company_id: "",
    no_of_phones_required: "",
    no_extensions_required: "",
    request_status: "",
  });

  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state?.userInfo?.user);
  const { data } = useSelector((state) => state?.modal?.modal);

  useEffect(() => {
    if (data) {
      setFormData({
        user_id: data?.user_id || userInfo?.id,
        company_id: data?.company_id || userInfo?.company_id,
        no_of_phones_required: data?.no_of_phones_required || "",
        no_extensions_required: data?.no_extensions_required || "",
        request_status: data?.request_status || "",
      });
    }
  });

  // const fetchRequest = async () => {
  //   try {
  //     const response = await apiClient.get("/requests");
  //   } catch {
  //     console.log("Request!");
  //   }
  // };

  const handleClosePopup = () => {
    dispatch(closeModal());
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // onSave({ ...formData, _id: request?._id });
    const payload = { ...formData, user_id: userInfo?.id, company_id: userInfo?.company_id };
    try {
      await apiClient.put(`/requests/${data?._id}`, payload);

      // fetchRequests();
      dispatch(
        closeModalWithUpdate({
          isUpdated: {
            isUpdatedIn: "UPDATE_REQUEST",
            data: null,
          },
        })
      );
    } catch (error) {
      console.error("Error saving request:", error);
    }
  };

  return (
    <div className={"rightModal taskModal"}>
      <div className="modal-header p-3">
        <h4 className="m-0">Edit Requests</h4>
        <button className="btnClose ms-auto" onClick={handleClosePopup}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        <Box component="form" onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <CustomInputBox
              icon={Phone}
              placeholder="Number of Phones Required"
              name="no_of_phones_required"
              value={formData?.no_of_phones_required}
              onChange={handleChange}
              backgroundColor={"#FFFFFF"}
            />
            <CustomInputBox
              icon={Numbers}
              placeholder="Number of Extensions Required"
              name="no_extensions_required"
              value={formData?.no_extensions_required}
              onChange={handleChange}
              backgroundColor={"#FFFFFF"}
            />

            <div className="d-flex justify-content-end gap-3 mb-4">
              <CustomButton variant="contained" color="secondary" onClick={handleClosePopup}>
                Cancel
              </CustomButton>
              <CustomButton type="submit" variant="contained" color="primary">
                Submit
              </CustomButton>
            </div>
          </Stack>
        </Box>
      </div>
    </div>
  );
};

export default EditRequest;
